<template>
  <input-type-ahead
    :value="optionId"
    :list="options"
    :searchchange="getCities"
    :selected-value="emitValue"
    option-value="id"
    option-text="display_name"
    label="Current Location"
    placeholder="Type a city name..."
  />
</template>

<script>
import UserClient from '@/api/UserClient';
import InputTypeAhead from '@/components/inputs/InputTypeAhead.vue';

export default {
  name: 'LocationPicker',

  components: {
    InputTypeAhead
  },

  props: {
    value: {
      type: Object,
      default: () => null
    }
  },

  data() {
    return {
      userClient: new UserClient(this.$http),

      timeout: null,
      optionId: 0,
      options: []
    };
  },

  watch: {
    async value() {
      if (!this.value) {
        this.optionId = 0;
      } else {
        this.optionId = this.value.id;
        if (this.options.indexOf(this.value) === -1) {
          this.options = [this.value];
        }
      }
    }
  },

  methods: {
    getCities(query) {
      if (this.optionId && !query) {
        return;
      }

      if (this.timeout) {
        clearTimeout(this.timeout);
      }

      this.timeout = setTimeout(async () => {
        const cities = await this.userClient.getCityList(query);
        this.options = cities.results || [];
      }, 300);
    },

    emitValue(id) {
      if (id <= 0) {
        return;
      }
      const city = this.options.find((c) => c.id === id);
      this.$emit('input', city);
    }
  }
};
</script>
